export default __webpack_public_path__ + "static/media/drone.37b23fe8.jpeg";